<div class="chart-container">
    <!-- scatter chart - Count or Duration -->
    @if (isReady && isHighcharts) {
        <highcharts-chart style="display: flex" [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"></highcharts-chart>
    } @else {
        <div>
            <app-loading [size]="'60px'" [style]="{ 'margin-top': '100px' }"></app-loading>
            <br />
            <div fxLayout="row" fxLayoutAlign="center center">
                <mat-icon>hourglass_empty</mat-icon>
                {{ "placeholder.makeTakeMinute" | transloco }} ...
            </div>
        </div>
    }
</div>
